
import React, { useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { tokens } from "../../theme";
import axios from 'axios';
import { useLocation, useNavigate } from "react-router-dom";
import Box from '@mui/material/Box';
import { useMediaQuery, useTheme, TextField, InputAdornment } from "@mui/material";
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { Button, IconButton } from '@mui/material';
import { Add, Edit, Delete, Print, Search, Refresh } from '@mui/icons-material';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import FilterListIcon from '@mui/icons-material/FilterList';
import AddVendor from './AddVendor';
import EditVendor from './EditVendor';
import env from "react-dotenv";
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import {
  createWorkbook,
  createWorksheet,
  addTitleRow,
  addSummaryRow,
  addHeaders,
  applyCellStyles,
  setColumnWidths
} from '../../utils/excelStyles'; // Import the Excel styling functions
import CustomSelect1 from '../../utils/CustomSelect1'; // Import the CustomSelect component

// Print Component
const PrintableVendorList = React.forwardRef(({ vendors }, ref) => (
  <div ref={ref} className="print-container">
    {/* <h2 className="print-title">Vendor List</h2> */}
    <table className="print-table">
      <thead>
        <tr>
          <th>Code</th>
          <th>Vendor Name</th>
          <th>Address</th>
          <th>Phone</th>
          <th>City</th>
          <th>State</th>
          <th>Pin Code</th>
          <th>GST No</th>
        </tr>
      </thead>
      <tbody>
        {vendors.map((vendor) => (
          <tr key={vendor.id}>
            <td>{vendor.vendor_code}</td>
            <td>{vendor.vendor_name}</td>
            <td>{vendor.address}</td>
            <td>{vendor.phone}</td>
            <td>{vendor.city}</td>
            <td>{vendor.state}</td>
            <td>{vendor.pin_code}</td>
            <td>{vendor.gst_no}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
));

const VendorList = () => {
  const [vendors, setVendors] = useState([]);
  const [searchTerm, setSearchTerm] = useState(''); // For search input
  const [openAdd, setOpenAdd] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [selectedVendor, setSelectedVendor] = useState(null);
  const printRef = useRef();
  const [filteredVendors, setFilteredVendors] = useState([]);
  const [showAdvancedFilters, setShowAdvancedFilters] = useState(false); // State for advanced filters
  const [selectedVendorNames, setSelectedVendorNames] = useState([]);
  const [selectedMaterials, setSelectedMaterials] = useState([]);
  const [selectedCities, setSelectedCities] = useState([]);
  const [selectedStates, setSelectedStates] = useState([]);
  const [uniqueVendorNames, setUniqueVendorNames] = useState([]);
  const [uniqueMaterials, setUniqueMaterials] = useState([]);
  const [uniqueCities, setUniqueCities] = useState([]);
  const [uniqueStates, setUniqueStates] = useState([]);

  // States to control dropdown opens separately
    const [openVendorNamesDropdown, setOpenVendorNamesDropdown] = useState(false);
    const [openMaterialsDropdown, setOpenMaterialsDropdown] = useState(false);
    const [openCitiesDropdown, setOpenCitiesDropdown] = useState(false);
    const [openStatesDropdown, setOpenStatesDropdown] = useState(false);

  const user = useSelector((state) => state.user);
  // const isAdmin = user?.role === 'Store Admin';
  const isAdmin = (user?.role === 'Admin' && user?.department?.includes('Store')) || 
                  (user?.role === 'Super Admin' && user?.department?.includes('Store'));

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    if (location.key == undefined || location.key == null || location.key == 'default') {
      navigate("/");
    }
  }, [location]);

  // const fetchVendors = () => {
    
  //   axios
  //     .get(`${process.env.REACT_APP_PJCBACKEND_URL}/api/vendors`)
  //     .then((response) => setVendors(response.data))
  //     .catch((error) => console.error('Error fetching vendors:', error));
  // };

  const fetchVendors = () => {
    axios
      .get(`${process.env.REACT_APP_PJCBACKEND_URL}/api/vendors`)
      .then((response) => {
        setVendors(response.data);
        setFilteredVendors(response.data); // Initialize filtered vendors
        // Extract unique materials, cities, states, and vendor names for filtering
        setUniqueVendorNames([...new Set(response.data.map(vendor => vendor.vendor_name))]);
        setUniqueMaterials([...new Set(response.data.map(vendor => vendor.product_list).flat())]);
        setUniqueCities([...new Set(response.data.map(vendor => vendor.city))]);
        setUniqueStates([...new Set(response.data.map(vendor => vendor.state))]);
      })
      .catch((error) => console.error('Error fetching vendors:', error));
  };

  useEffect(() => {
    fetchVendors();
  }, []);

  // const handleSearch = (e) => {
  //   const value = e.target.value.toLowerCase();
  //   setSearchTerm(value);

  //   const filtered = vendors.filter((vendor) =>
  //     Object.values(vendor)
  //       .join(' ')
  //       .toLowerCase()
  //       .includes(value)
  //   );
  //   setVendors(filtered);
  // };

//   const handleSearch = (e) => {
//     const value = e.target.value.toLowerCase();
//     setSearchTerm(value);
//     if (!value) {
//       fetchVendors(); // Reset vendors when search is cleared
//       return;
//     }

//     const filtered = vendors.filter((vendor) =>
//       Object.values(vendor).some((field) =>
//         field && field.toString().toLowerCase().includes(value)
//       )
//     );

//     setVendors(filtered);
// };

const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);
    filterVendors(value, selectedVendorNames, selectedMaterials, selectedCities, selectedStates);
  };

  const filterVendors = (searchTerm, selectedVendorNames, selectedMaterials, selectedCities, selectedStates) => {
    const filtered = vendors.filter((vendor) => {
      const matchesSearch = Object.values(vendor).some(field => 
        field && field.toString().toLowerCase().includes(searchTerm.toLowerCase())
      );
      const matchesVendorName = selectedVendorNames.length === 0 || selectedVendorNames.includes(vendor.vendor_name);
      const matchesMaterial = selectedMaterials.length === 0 || (vendor.product_list && selectedMaterials.some(material => vendor.product_list.includes(material)));
      const matchesCity = selectedCities.length === 0 || selectedCities.includes(vendor.city);
      const matchesState = selectedStates.length === 0 || selectedStates.includes(vendor.state);
      return matchesSearch && matchesVendorName && matchesMaterial && matchesCity && matchesState;
    });
    setFilteredVendors(filtered);
  };

  const handleVendorNameChange = (selectedValues) => {
    setSelectedVendorNames(selectedValues);
    filterVendors(searchTerm, selectedValues, selectedMaterials, selectedCities, selectedStates);
  };

  const handleMaterialChange = (selectedValues) => {
    setSelectedMaterials(selectedValues);
    filterVendors(searchTerm, selectedVendorNames, selectedValues, selectedCities, selectedStates);
  };

  const handleCityChange = (selectedValues) => {
    setSelectedCities(selectedValues);
    filterVendors(searchTerm, selectedVendorNames, selectedMaterials, selectedValues, selectedStates);
  };

  const handleStateChange = (selectedValues) => {
    setSelectedStates(selectedValues);
    filterVendors(searchTerm, selectedVendorNames, selectedMaterials, selectedCities, selectedValues);
  };

  const handleExport = async () => {
    const workbook = createWorkbook();
    const worksheet =createWorksheet(workbook, 'Vendors');
    addTitleRow(worksheet, 'Vendors List');
    addSummaryRow(worksheet, 'Summary of Vendors');
    // Add header rows
    const headers = ['Code', 'Vendor Name', 'Raw Materials', 'Address', 'Phone', 'City', 'State', 'Pin Code', 'GST No'];
    addHeaders(worksheet, headers);
    // Add data rows
    filteredVendors.forEach(vendor => {
      worksheet.addRow([
        vendor.vendor_code || '',
        vendor.vendor_name || '',
        vendor.product_list || '',
        vendor.address || '',
        vendor.phone || '',
        vendor.city || '',
        vendor.state || '',
        vendor.pin_code || '',
        vendor.gst_no  || '',
      ]);
    });
    applyCellStyles(worksheet);
    setColumnWidths(worksheet, [15, 40, 50, 50, 18, 20, 25, 15, 25]); // Set column widths
    // Save the workbook
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/octet-stream' });
    saveAs(blob, 'VendorsData.xlsx');
  };

  const clearFilters = () => {
    setSearchTerm("");
    setSelectedVendorNames([]);
    setSelectedMaterials([]);
    setSelectedCities([]);
    setSelectedStates([]);
    setFilteredVendors(vendors); // Reset filtered vendors to all vendors
  };

  const handleOpenAdd = () => setOpenAdd(true);
  const handleOpenEdit = (vendor) => {
    setSelectedVendor(vendor);
    setOpenEdit(true);
  };
  const handleCloseAdd = () => setOpenAdd(false);
  const handleCloseEdit = () => setOpenEdit(false);
  const handleDeleteVendor = (id) => {
    axios
      .delete(`${process.env.REACT_APP_PJCBACKEND_URL}/api/vendors/${id}`)
      .then(() => fetchVendors())
      .catch((error) => console.error('Error deleting vendor:', error));
  };

  // Print function with custom styles
  const handlePrint = () => {
    const printContent = printRef.current;
    const WinPrint = window.open('', '', 'width=900,height=650');
    WinPrint.document.write(`
      <html><head><title>Print Vendor Report</title>
      <style>
        body { font-family: Arial, sans-serif; margin: 20px; }
        .print-title { text-align: center; font-size: 24px; font-weight: bold; margin-bottom: 20px; }
        .print-table { width: 100%; border-collapse: collapse; margin-top: 10px; }
        .print-table th, .print-table td { padding: 8px; border: 1px solid #ddd; text-align: left; }
        .print-table th { background-color: #f4f4f4; font-weight: bold; }
        .print-footer { margin-top: 20px; text-align: center; font-size: 14px; color: #555; }
      </style>
      </head><body>
      <div class="print-title">Vendor Report</div>
      ${printContent.innerHTML}
      <div class="print-footer">Generated on ${new Date().toLocaleDateString()}</div>
      </body></html>
    `);
    WinPrint.document.close();
    WinPrint.print();
  };

  const columns = [
    { field: 'vendor_code', headerName: 'Code', width: 80 },
    { field: 'vendor_name', headerName: 'Vendor Name', width: 170 },
    { field: 'product_list', headerName: 'Raw Materials', width: 170 },
    { field: 'address', headerName: 'Address', width: 170 },
    { field: 'phone', headerName: 'Phone', width: 100 },
    { field: 'city', headerName: 'City', width: 100 },
    { field: 'state', headerName: 'State', width: 120 },
    { field: 'pin_code', headerName: 'Pin Code', width: 70 },
    { field: 'gst_no', headerName: 'GST No', width: 140 },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 100,
      headerAlign: 'center', // Center align the header text
      align: 'center',       // Optional: center align the cell contents too
      renderCell: (params) => (
        <div>
          {isAdmin && (
            <>
              <IconButton color="primary" onClick={() => handleOpenEdit(params.row)}>
                <Edit />
              </IconButton>
              <IconButton color="secondary" onClick={() => handleDeleteVendor(params.row.id)}>
                <Delete />
              </IconButton>
            </>
          )}
        </div>
      ),
    },
  ];

  return (
    <Box style={{  
      height: 500,
      width: '95%',
      marginLeft:"180px",
      paddingRight:"90px",
      marginTop:"0px" 
      }}>

        {isAdmin && (
          <Button
            // variant="contained"
            color="primary"
            onClick={handleOpenAdd}
            sx={{
              // marginLeft: "auto",
              marginTop: "5px",
              marginBottom: "10px",
              marginRight: "10px",
              // backgroundColor: '#00308F',
              // color: '#ffffff',
              padding: '3px 5px',
              // '&:hover': {
              //   backgroundColor: '#00207E',
              // },
            }}
          >
            Add
          </Button>
        )}
        
        {/* <Button
          variant="contained"
          color="primary"
          onClick={handlePrint}
          startIcon={<Print />}
          sx={{
            marginLeft: "10px",
            backgroundColor: '#4CAF50',
            color: '#ffffff',
            padding: '3px 5px',
            '&:hover': {
              backgroundColor: '#388E3C',
            },
          }}
        >
          Print
        </Button> */}
         
      {/* </Box> */}

           
            <TextField
                variant="outlined"
                size="small"
                placeholder="Search"
                value={searchTerm}
                onChange={handleSearch}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search />
                    </InputAdornment>
                  ),
                }}
                sx={{ 
                    width: '970px', // Set the desired width here
                    marginTop: "5px",
                    marginBottom: "10px",
                    marginLeft: "0px",
                    marginRight: "10px",
                    backgroundColor: '#ffffff',
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': {
                        borderColor: '#00308F',
                      },
                      '&:hover fieldset': {
                        borderColor: '#00207E',
                      },
                    },
                  }}
              />
              
      <Button
        onClick={() => setShowAdvancedFilters(!showAdvancedFilters)}
        startIcon={<FilterListIcon />}
      >
        Filter
      </Button>

      <Button 
        onClick={handleExport}
        startIcon={<SaveAltIcon />}
        sx={{
          marginLeft: "10px",
          marginTop: "5px",
          marginBottom: "10px",
        }}
      >
        Export
      </Button>

        <IconButton
          onClick={() => window.location.reload()} // Refresh the page
          color="primary"
          sx={{
              backgroundColor: '#ffffff',
              '&:hover': {
                          backgroundColor: '#f0f0f0',
                         },
              }}
        >
         <Refresh />
        </IconButton>

      {showAdvancedFilters && (
        <Box sx={{ marginTop: "15px", marginBottom: "10px", display: "flex", gap: "10px", flexWrap: "wrap" }}>

          <CustomSelect1
            label="Vendor"
            value={selectedVendorNames}
            onChange={handleVendorNameChange}
            options={uniqueVendorNames}
            open={openVendorNamesDropdown}
            setOpen={setOpenVendorNamesDropdown}
            getOptionLabel={(option) => option} // Adjust based on your object structure
          />

          <CustomSelect1
            label="Raw Material"
            value={selectedMaterials}
            onChange={handleMaterialChange}
            options={uniqueMaterials}
            open={openMaterialsDropdown}
            setOpen={setOpenMaterialsDropdown}
            getOptionLabel={(option) => option} // Adjust based on your object structure
          />

          <CustomSelect1
            label="City"
            value={selectedCities}
            onChange={handleCityChange}
            options={uniqueCities}
            open={openCitiesDropdown}
            setOpen={setOpenCitiesDropdown}
            getOptionLabel={(option) => option} // Adjust based on your object structure
          />

          <CustomSelect1
            label="State"
            value={selectedStates}
            onChange={handleStateChange}
            options={uniqueStates}
            open={openStatesDropdown}
            setOpen={setOpenStatesDropdown}
            getOptionLabel={(option) => option} // Adjust based on your object structure
          />

          <Button onClick={clearFilters}>Clear Filter</Button>

        </Box>
      )}

      <Box sx={{ height: 500, overflowY: 'auto' }}>
        <DataGrid
          // rows={vendors}
          rows={filteredVendors}
          columns={columns}
          getRowId={(row) => row.id}
          pageSizeOptions={[10, 25, 50]}
          checkboxSelection
          disableRowSelectionOnClick
          // slots={{ toolbar: GridToolbar }}
          sx={{
            boxShadow: 1,
            border: 1,
            borderColor: 'primary.light',
            '& .MuiDataGrid-cell:hover': {
              color: 'primary.main',
            },
          }}
        />
      </Box>

      <div style={{ display: 'none' }}>
        <PrintableVendorList ref={printRef} vendors={vendors} />
      </div>

      <AddVendor open={openAdd} handleClose={handleCloseAdd} fetchVendors={fetchVendors} />
      {selectedVendor && (
        <EditVendor
          open={openEdit}
          handleClose={handleCloseEdit}
          vendorData={selectedVendor}
          fetchVendors={fetchVendors}
        />
      )}
    </Box>
  );
};

export default VendorList;
